export default __webpack_public_path__ + "static/media/P-022.41611860.png";